import React, { useState } from 'react';
import AdminService from '../../../API/AdminService';
import styles from './CommentForm.module.css';
import logger from '../../../utils/logger';
const CommentForm = ({ topicId, onCommentAdded, parentCommentId = null }) => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const commentData = {
            content: content.trim(),
            ...(parentCommentId && { parent_comment_id: parentCommentId })
        };

        // Валидация
        const validationErrors = AdminService.validateCommentData(commentData);
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            setLoading(true);
            await AdminService.createForumComment(topicId, commentData);
            setContent('');
            setErrors([]);
            onCommentAdded();
        } catch (error) {
            setErrors(['Ошибка добавления комментария. Попробуйте еще раз.']);
            logger.error('Ошибка создания комментария:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.commentFormContainer}>
            <h3>{parentCommentId ? 'Ответить на комментарий' : 'Добавить комментарий'}</h3>
            
            <form onSubmit={handleSubmit} className={styles.commentForm}>
                {errors.length > 0 && (
                    <div className={styles.errorMessages}>
                        {errors.map((error, index) => (
                            <p key={index} className={styles.errorMessage}>{error}</p>
                        ))}
                    </div>
                )}

                <div className={styles.formGroup}>
                    <textarea
                        value={content}
                        onChange={(e) => {
                            setContent(e.target.value);
                            if (errors.length > 0) setErrors([]);
                        }}
                        placeholder="Напишите ваш комментарий..."
                        rows="4"
                        maxLength="5000"
                        className={styles.commentTextarea}
                        disabled={loading}
                    />
                    <small className={styles.charCounter}>
                        {content.length}/5000 символов
                    </small>
                </div>

                <div className={styles.formActions}>
                    {parentCommentId && (
                        <button 
                            type="button"
                            onClick={() => onCommentAdded()}
                            className={styles.cancelButton}
                            disabled={loading}
                        >
                            Отмена
                        </button>
                    )}
                    <button 
                        type="submit"
                        className={styles.submitButton}
                        disabled={loading || !content.trim()}
                    >
                        {loading ? 'Отправляю...' : 'Отправить комментарий'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CommentForm;